import { FunctionComponent } from 'react';
import { CaptionProps, useNavigation } from 'react-day-picker';
import cx from 'classnames';
import YearMonthForm from 'lib/DatePicker/YearMonthForm';
import Button, { Color } from 'lib/Button';
import arrowLightLeft from 'assets/icons/arrow_light_left.svg';
import arrowLightRight from 'assets/icons/arrow_light_right.svg';

export type CalendarCaptionProps = CaptionProps & {
  onMonthChange: (date: Date) => void;
  fromMonth?: Date;
  toMonth?: Date;
  yearsBefore?: number;
  yearsAfter?: number;
  navigationWidth?: string;
  isCompact?: boolean;
};

const CalendarCaption: FunctionComponent<CalendarCaptionProps> = ({
  displayMonth,
  onMonthChange,
  fromMonth,
  toMonth,
  yearsBefore,
  yearsAfter,
  navigationWidth,
  isCompact = false,
}) => {
  const { goToMonth, previousMonth, nextMonth } = useNavigation();

  const handleMonthChange = (newDate: Date): void => {
    goToMonth(newDate);
    onMonthChange(newDate);
  };

  const buttonClass = isCompact
    ? 'w-9 h-9 flex items-center justify-center z-30 pointer-events-auto'
    : 'w-10 h-10 flex items-center justify-center z-30 pointer-events-auto';

  const svgClass = isCompact ? 'text-primary w-5 h-5' : 'text-primary w-6 h-6';

  const navContainerClass = navigationWidth
    ? cx('absolute flex justify-between top-0 left-1/2 -translate-x-1/2 pointer-events-none', navigationWidth)
    : 'absolute flex justify-between top-0 left-0 w-full pointer-events-none';

  return (
    <div className="rdp-caption relative">
      <YearMonthForm
        date={displayMonth}
        onChange={handleMonthChange}
        fromMonth={fromMonth}
        toMonth={toMonth}
        yearsBefore={yearsBefore}
        yearsAfter={yearsAfter}
      />
      <div className={navContainerClass}>
        <Button
          onClick={() => {
            if (previousMonth) handleMonthChange(previousMonth);
          }}
          svg={arrowLightLeft}
          color={Color.SECONDARY}
          classNames={buttonClass}
          svgClassnames={svgClass}
        />
        <Button
          onClick={() => {
            if (nextMonth) handleMonthChange(nextMonth);
          }}
          svg={arrowLightRight}
          color={Color.SECONDARY}
          classNames={buttonClass}
          svgClassnames={svgClass}
        />
      </div>
    </div>
  );
};

export default CalendarCaption;
